import Layout from "../../../components/Layout/Layout";
import PageHeader from "../../../components/PageHeader/PageHeader";
import SectionTitle from "../../../components/SectionTitle/SectionTitle";
import styles from "./Client.module.css";

export default function AboutClient() {
  return (
    <Layout>
      <PageHeader
        gnbname="about"
        title="고객사"
        destription="엔아이시스템은 신뢰와 약속을 바탕으로 다양한 분야의 기업들과 계약을 진행했습니다."
      />
      <main className={styles.about_client}>
        <SectionTitle title="국내" />
        <DomesticSection />
        <SectionTitle title="해외" />
        <OverseasSection />
      </main>
    </Layout>
  );
}

function DomesticSection() {
  return (
    <section className={`${styles.domestic} inner`}>
      <dl>
        <dt>콘텐츠브릿지</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_message_partner2.png`}
            alt="콘텐츠브릿지 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <p>서진시스템</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_01.svg`}
            alt="서진시스템 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>한국자동차모빌리티산업협회</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_kama.svg`}
            alt="한국자동차모빌리티산업협회 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>엑셈</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_axem.svg`}
            alt="엑셈 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>제주항공</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_jeju.svg`}
            alt="제주항공 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>아이포웨이</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_i4way.svg`}
            alt="아이포웨이 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>에듀베이션</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_edu.svg`}
            alt="에드베이션 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>위즈위클리</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_wiz.svg`}
            alt="위즈위클리 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>피앤씨솔루션</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_pc.svg`}
            alt="피앤씨솔루션 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>티웨이항공</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_tway.png`}
            alt="티웨이항공 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>나우코스</dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_message_tway.png`}
            alt="나우코스 로고"
          />
        </dd>
      </dl>
    </section>
  );
}

function OverseasSection() {
  return (
    <section className={`${styles.overseas} inner`}>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/vietnam.svg`}
            alt="베트남 국기"
          />
          <p>서진시스템 비나</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_01.svg`}
            alt="서진시스템 비나 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/vietnam.svg`}
            alt="베트남 국기"
          />
          <p>서진 비나</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_01.svg`}
            alt="서진 비나 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/vietnam.svg`}
            alt="베트남 국기"
          />
          <p>서진 오토</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_01.svg`}
            alt="서진 오토 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/vietnam.svg`}
            alt="베트남 국기"
          />
          <p>서진 베트남</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_01.svg`}
            alt="서진 베트남 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/vietnam.svg`}
            alt="베트남 국기"
          />
          <p>텍슨 베트남</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/partner_logo_02.svg`}
            alt="텍슨 베트남 로고"
          />
        </dd>
      </dl>
      <dl>
        <dt>
          <img
            src={`${process.env.PUBLIC_URL}/images/about/about_client_ indonesia.svg`}
            alt="인도네시아 국기"
          />
          <p>오로라월드</p>
        </dt>
        <dd>
          <img
            src={`${process.env.PUBLIC_URL}/images/aurora.svg`}
            alt="오로라월드 로고"
          />
        </dd>
      </dl>
    </section>
  );
}
